import { z } from "zod";

export const contactSchema = z.object({
  name: z.string().trim().min(1, "Name required").max(120, "Name too long"),
  email: z.string().trim().email("Invalid email").max(200),
  company: z.string().trim().max(150).optional().or(z.literal("")),
  message: z.string().trim().min(1, "Message required").max(2000, "Message too long"),
  request_type: z.enum(["operations", "consulting", "tech", "other"]),
  consent: z.literal(true, { message: "Consent required" }),
});

export type ContactInput = z.infer<typeof contactSchema>;
